import { useTranslation } from 'react-i18next';
import { senderIdentifierHeadingKey } from '@/lib/referral/senderIdentifier';

/** G5/G6: "Ydernummer 012345" / "SOR-nummer …" / "Identifikation …" — the same for every party. */
export function PartyIdentifier({ party }: { party: { identifier?: string; identifierCode?: string } | null }) {
  const { t } = useTranslation();
  if (!party?.identifier) return null;
  return (
    <span className="text-xs text-ds-muted" data-testid="epikrise-party-identifier">
      {' · '}
      {t(senderIdentifierHeadingKey(party.identifierCode))} {party.identifier}
    </span>
  );
}
